export const RecommendationTypes = {
    PRODUCT_SERIES: 'productseries',
    SHOP_THE_LOOK: 'shop-the-look',
    THOR_OUTFIT: 'outfit',
    BOUGHT_TOGETHER: 'bought-together',
    COMPLEMENTARY_ARTICLES: 'complementary-articles',
    OUTFITS: 'outfits'
}
